import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import { ConsentProvider } from './lib/consent';
import CookieConsentBanner from './components/CookieConsentBanner';
import VisitTracker from './components/VisitTracker';
import AppRoutes from './AppRoutes';

export default function App() {
  return (
    <BrowserRouter>
      <ConsentProvider>
        <AuthProvider>
          <VisitTracker />
          <AppRoutes />
          <CookieConsentBanner />
        </AuthProvider>
      </ConsentProvider>
    </BrowserRouter>
  );
}
